(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('EditSkillController', EditSkillController);

    function EditSkillController($state, $stateParams, $q, $translate, config, logger, skill, catalogItems, notifyingService, dataService) {
        var vm = this;
        
        vm.item = skill.item;
        vm.activityExaminers = skill.activityExaminers;
        vm.catalogItems = catalogItems;
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel() {
            $state.go('^');
        }

        function save(formData) {
            if (!formData.$valid) {
                logger.error('some_mandatory_fields_have_not_yet_been_filled');
                return $q.reject();
            }

            if (config.settings.custom.examinerRequiredFor) {
                var examinersRequired = false;
                for (var x = 0; x < config.settings.custom.examinerRequiredFor.length; x++) {
                    var t = config.settings.custom.examinerRequiredFor[x].toLowerCase();
                    for (var y = 0; y < vm.item.activityGroups.length; y++) {
                        var ag = vm.item.activityGroups[y];
                        for (var z = 0; z < ag.activities.length; z++) {
                            var a = ag.activities[z];
                            if (a.type === t && (a.examiners === undefined || a.examiners.length === 0)) {
                                examinersRequired = true;
                                break;
                            }
                        }
                        if (examinersRequired == true) break;
                    }
                    if (examinersRequired == true) break;
                }

                if (examinersRequired) {
                    logger.error('for_one_or_more_activities_no_assessors_have_been_added_yet');
                    return $q.reject();
                }
            }

            return dataService
                .saveSkill(vm.item, skill.changeVector, formData.setValidityForExistingAssignments)
                .then(result => {
                    logger.success('successfully_saved');
                    $state.go('^');
                });
        }
    }
})();